import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles, MenuItem, Select, TextField } from '@material-ui/core'
import { Home } from '@material-ui/icons'


const useStyles = makeStyles(theme => ({
    root: props => (
        {
            backgroundColor: props.color === "secondary" ? theme.palette.secondary.main : props.color === "primary" ? theme.palette.primary.main : theme.palette.background.paper,
            borderRadius: theme.shape.borderRadius,
            color: props.color === "secondary" ? theme.palette.secondary.contrastText : props.color === "primary" ? theme.palette.primary.contrastText : theme.palette.text.primary,
            '& svg': {
                fill:props.color === "secondary" ? theme.palette.secondary.contrastText : props.color === "primary" ? theme.palette.primary.contrastText : theme.palette.text.primary,
            },
            '& div': {
                padding: theme.spacing(2),
            },
            '&::before': {
                borderBottomWidth: 0,
            },
            '&::after': {
                borderBottomWidth: 0,
            },
        }
    ),
}))

const Selector = props => {

    const classes = useStyles(props);

    return (
        <Select
            className={classes.root}
            {...props}
        >
            {props.options.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                    {option.label}
                </MenuItem>
            ))}
        </Select>
    )
}

Selector.propTypes = {
    /**
     * Array of options object, {label:"",value:object}
     */
    options: PropTypes.array.isRequired,
    variant: PropTypes.oneOf(["filled","outlined","standard"])
}

Selector.defaultProps = {
    fullWidth:true,
    variant:"outlined"    
};

export default Selector
